import { Routes } from '@angular/router';
import { AdminGuardService } from '../common/guards/admin-guard.service';

import { AccueilComponent } from './accueil/accueil.component';
import { CommentsComponent } from './comments/comments.component';
import { DocumentEditComponent } from './documents/document-edit/document-edit.component';
import { DocumentNewComponent } from './documents/document-new/document-new.component';
import { DocumentsComponent } from './documents/documents.component';
import { ImageEditComponent } from './images/image-edit/image-edit.component';
import { ImageNewComponent } from './images/image-new/image-new.component';
import { ImagesComponent } from './images/images.component';
import { PageEditComponent } from './pages/page-edit/page-edit.component';
import { PageNewComponent } from './pages/page-new/page-new.component';
import { PagesComponent } from './pages/pages.component';
import { SettingsComponent } from './settings.component';
import { GestionnaireGuardService } from '../common/guards/gestionnaire-guard.service';
import {CaneditGuardService} from '../common/guards/canedit-guard.service';
import {FeedbacksComponent} from './feedbacks/feedbacks.component';


export const ROUTES: Routes = [
  {
    path: 'settings',
    canLoad: [GestionnaireGuardService],
    canActivate: [GestionnaireGuardService],
    component: SettingsComponent,
    children: [
      {
        path: '',
        component: AccueilComponent
      },
      {
        path: 'comments',
        component: CommentsComponent
      },
      {
        path: 'feedbacks',
        component: FeedbacksComponent
      },
      {
        path: 'documents/new',
        component: DocumentNewComponent
      },
      {
        path: 'documents/:id/edit',
        component: DocumentEditComponent
      },
      {
        path: 'documents',
        component: DocumentsComponent
      },
      {
        path: 'images/new',
        component: ImageNewComponent
      },
      {
        path: 'images/:id/edit',
        component: ImageEditComponent
      },
      {
        path: 'images',
        component: ImagesComponent
      },
      {
        path: 'pages/new',
        component: PageNewComponent
      },
      {
        canLoad: [CaneditGuardService],
        canActivate: [CaneditGuardService],
        path: 'pages/:id/edit',
        component: PageEditComponent
      },
      {
        path: 'pages',
        component: PagesComponent,
      },
    ]
  }
];

